function merch38WidgetsInit () {
  document.querySelectorAll('[data-merch38-id]').forEach(function (el) {
    var defaultColor = el.getAttribute('data-merch38-defaultColor')
    window.merch38Widget({
      el: el,
      defaultColor: defaultColor || 'black',
      campaignId: el.getAttribute('data-merch38-id'),
      appearance: {
        mainColor: '#5062c2',
        btnText: 'BUY',
        btnTextColor: '#ffffff'
      }
    })
  })

}
document.addEventListener("DOMContentLoaded", merch38WidgetsInit)


// WEBPACK FOOTER //
// ./source/assets/js/widgets.js